import { FileText } from "lucide-react";
import type { IconTyp } from "./Briefgeist";
import { KATEGORIEN } from "./kategorieSymbole";

/** Kachel 36 (Radius 10) mit Kategorie-Symbol 20 (dekorativ; die Kategorie steht immer auch als Text
 *  da). `ton="akzent"`: Handlung (Akzent-Toenung), etwa Einstiege in Einstellungen. `ton="flaeche"`:
 *  zweite Flaeche mit Symbol in Text 2 wie BriefgeistKachel der iOS-App (Chats im Verlauf, W22d-w6). */
export function Kachel(props: { schluessel: string | null | undefined; icon?: IconTyp; ton?: "akzent" | "neutral" | "flaeche" }) {
  const Icon: IconTyp = props.icon ?? (props.schluessel ? KATEGORIEN[props.schluessel] : undefined) ?? FileText; // ohne Kategorie: Brief, kein kreisfoermiges Ersatzsymbol (W22b)
  const farbe = props.ton === "akzent" ? "bg-pg-accent-soft text-pg-accent-text" : props.ton === "flaeche" ? "bg-pg-surface-2 text-pg-text-2" : "text-pg-text-2";
  return (
    <span className={`kachel grid size-(--size-tile) shrink-0 place-items-center rounded-tile ${farbe}`} data-ton={props.ton ?? "neutral"}>
      <Icon size={20} strokeWidth={1.75} aria-hidden />
    </span>
  );
}

/** 8-px-Punkt der dichten Desktop-Zeile (neutral). */
export function Punkt(props: { schluessel: string | null | undefined }) {
  return <span aria-hidden data-kategorie={props.schluessel ?? undefined} className="mt-2 size-2 shrink-0 rounded-pill bg-pg-text-3" />;
}
